import { Case } from "./types";

export const roles: Case[] = [
  {
    title: "Administrative",
    identifier: "administrative",
  },
  {
    title: "Customer Service",
    identifier: "customer-service",
  },
  {
    title: "Ecommerce",
    identifier: "ecommerce",
  },
  {
    title: "Executive Leadership",
    identifier: "executive-leadership",
  },
  {
    title: "Finance and Accounting",
    identifier: "finance-and-accounting",
  },
  {
    title: "Health and Safety",
    identifier: "health-and-safety",
  },
  {
    title: "Human Resources",
    identifier: "human-resources",
  },
  {
    title: "Information Technology",
    identifier: "information-technology",
  },
  {
    title: "Legal",
    identifier: "legal",
  },
  {
    title: "Management",
    identifier: "management",
  },
  {
    title: "Operations",
    identifier: "operations",
  },
  {
    title: "Product Development",
    identifier: "product-development",
  },
  {
    title: "Project Management",
    identifier: "project-management",
  },
  {
    title: "Public Relations",
    identifier: "public-relations",
  },
  {
    title: "Quality Assurance",
    identifier: "quality-assurance",
  },
  {
    title: "Research and Development",
    identifier: "research-and-development",
  },
  {
    title: "Sales and Marketing",
    identifier: "sales-and-marketing",
  },
];
